const selectors = {
    grid: '#product-grid',
    button: '.more-button',
    buttonLabel: '.button-label',
    loadingSpinner: '.loading__spinner',
    filter: '#main-collection-filters'
};

let grid, button, buttonLabel, loadingSpinner, filter, handle, allProductsCount, scrollAction;
let intersectionObserver;
let isFetching = false;

function updateSelectors() {
    grid = document.querySelector(selectors.grid);
    button = document.querySelector(selectors.button);
    buttonLabel = button ? button.querySelector(selectors.buttonLabel) : null;
    loadingSpinner = button ? button.querySelector(selectors.loadingSpinner) : null;
    filter = document.querySelector(selectors.filter);
    handle = button ? button.dataset.collectionHandle : null;
    allProductsCount = button ? parseInt(button.dataset.collectionCount) : 0;
    scrollAction = button ? button.dataset.scrollAction : null;
}

function initEventListeners() {
    if (scrollAction === 'scroll') {
        onScroll();
    } else if (scrollAction === 'click') {
        button.addEventListener('click', onClick);
    }
}

function onClick() {
    infinityScroll(button);
}

function onScroll() {
    const options = {
        root: null,
        rootMargin: '0px',
        threshold: 0.1
    };
    intersectionObserver = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting && grid.childElementCount < allProductsCount) {
                infinityScroll(button);
            }
        });
    }, options);
    intersectionObserver.observe(button);
}

async function infinityScroll(button) {
    if (isFetching) return;
    isFetching = true;
    changeLoadingLabel();
    const paginate = parseInt(button.dataset.paginate);
    const current = parseInt(button.dataset.collection);
    const next = current + 1;
    const urlParams = new URLSearchParams(window.location.search);
    urlParams.set('page', next);
    try {
        const response = await fetch(`/collections/${handle}?${urlParams.toString()}`);
        if (!response.ok) throw new Error('Network response was not ok');
        const text = await response.text();
        const parser = new DOMParser();
        const htmlDocument = parser.parseFromString(text, 'text/html');
        const gridInner = htmlDocument.querySelector(selectors.grid).innerHTML;
        grid.insertAdjacentHTML('beforeend', gridInner);
        if (paginate === next) {
            button.classList.add('hidden');
        } else {
            button.dataset.collection = next;
            changeDefaultLabel();
        }
    } catch (error) {
        console.error('Error fetching products:', error);
    } finally {
        isFetching = false;
    }
}

function changeLoadingLabel() {
    if (buttonLabel) buttonLabel.classList.add('hidden');
    if (loadingSpinner) loadingSpinner.classList.remove('hidden');
}

function changeDefaultLabel() {
    if (buttonLabel) buttonLabel.classList.remove('hidden');
    if (loadingSpinner) loadingSpinner.classList.add('hidden');
}

updateSelectors();
initEventListeners();

const observer = new MutationObserver(() => {
    updateSelectors();
    initEventListeners();
});
observer.observe(filter, { childList: true, subtree: true });